const slugg = require('slugg')

const buildPath = career =>
  '/careers/' +
  [career.dealership && career.dealership.slug, slugg(career.title), career._id]
    .filter(f => !!f)
    .join('/')

module.exports = buildPath
